import React, { useMemo } from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { defineMessages, useIntl } from 'react-intl';
import Styled from './styles';
import ChatListItem from './chat-list-item/component';
import useChat from '/imports/ui/core/hooks/useChat';
import { Chat } from '/imports/ui/Types/chat';
import { GraphqlDataHookSubscriptionResponse } from '/imports/ui/Types/hook';
import deviceInfo from '/imports/utils/deviceInfo';
import roveBuilder from '/imports/ui/core/utils/keyboardRove';

const { isMobile } = deviceInfo;
// const PUBLIC_GROUP_CHAT_ID = CHAT_CONFIG?.public_group_id;
const intlMessages = defineMessages({
  messagesTitle: {
    id: 'app.userList.messagesTitle',
    description: 'Title for the messages list',
  },
});

interface ChatListProps {
  chats: Chat[],
}

const getActiveChats = (chats: Chat[], chatNodeRef: React.Ref<HTMLButtonElement>) => chats.map((chat, idx) => (
  <CSSTransition
    classNames="transition"
    appear
    enter
    exit={false}
    timeout={0}
    component="div"
    key={chat.chatId}
    nodeRef={chatNodeRef}
  >
    <Styled.ListTransition>
      {chat.chatId !== 'MAIN-PUBLIC-GROUP-CHAT'
        && <ChatListItem
          chat={chat}
          chatNodeRef={chatNodeRef}
          index={idx}
        />
      }

    </Styled.ListTransition>
  </CSSTransition>
));

const ChatList: React.FC<ChatListProps> = ({ chats }) => {
  const messageListRef = React.useRef<HTMLDivElement | null>(null);
  const messageItemsRef = React.useRef<HTMLDivElement | null>(null);
  const chatNodeRef = React.useRef<HTMLButtonElement | null>(null);

  const rove = useMemo(() => roveBuilder(messageItemsRef, 'chat-list'), []);

  const intl = useIntl();
  return (
    <Styled.Messages>
      <Styled.Container>
        <Styled.MessagesTitle data-test="messageTitle">
          {intl.formatMessage(intlMessages.messagesTitle)}
        </Styled.MessagesTitle>
      </Styled.Container>
      {!isMobile ? (
        <Styled.ScrollableList
          role="tabpanel"
          tabIndex={0}
          ref={messageListRef}
          onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => rove(e)}
        >
          <Styled.List ref={messageItemsRef}>
            <TransitionGroup>
              {getActiveChats(chats, chatNodeRef) ?? null}
            </TransitionGroup>
          </Styled.List>
        </Styled.ScrollableList>
      )
        : (getActiveChats(chats, chatNodeRef) ?? null)}
    </Styled.Messages>
  );
};

const ChatListContainer: React.FC = () => {
  const { data: chats } = useChat((chat) => chat) as GraphqlDataHookSubscriptionResponse<Chat[]>;
 
  let count = 0;
  if (Array.isArray(chats)) {
    count = chats.filter(chat => chat.chatId !== 'MAIN-PUBLIC-GROUP-CHAT').length;
  }
  if (chats && count>0) {
    return (
      <ChatList chats={chats} />
    );
  } return <></>;
};

export default ChatListContainer;
